import { Link } from "react-router-dom";
import { ArrowLeft, Info } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { FadeUp } from "@/components/motion/Reveal";

export default function LegalPage({ page }) {
  const { t } = useLanguage();
  const content = t.legal[page];

  return (
    <main data-testid={`${page}-page`} className="blueprint-grid bg-[#FAFAFA] pb-24 pt-28 md:pt-36">
      <div className="mx-auto max-w-3xl px-5 md:px-8">
        <FadeUp>
          <Link
            to="/"
            data-testid={`${page}-back-link`}
            className="group mb-10 inline-flex items-center gap-2 text-sm font-medium text-navy/70 transition-colors hover:text-navy"
          >
            <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1" />
            {t.legal.back}
          </Link>
        </FadeUp>

        <FadeUp delay={0.05}>
          <h1 className="font-display text-4xl font-bold tracking-tight text-navy sm:text-5xl">
            {content.title}
          </h1>
        </FadeUp>

        <FadeUp delay={0.1}>
          <div
            data-testid={`${page}-placeholder-note`}
            className="mt-8 flex items-start gap-3 border-l-2 border-brand bg-navy-50 p-5"
          >
            <Info className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
            <p className="text-sm leading-relaxed text-navy/80">{t.legal.placeholderNote}</p>
          </div>
        </FadeUp>

        <div className="mt-12 space-y-10">
          {content.blocks.map((b, i) => (
            <FadeUp key={i} delay={0.1 + i * 0.05}>
              <section data-testid={`${page}-block-${i + 1}`}>
                <h2 className="mb-3 font-display text-xl font-bold tracking-tight text-navy">{b.heading}</h2>
                <p className="whitespace-pre-line text-base leading-relaxed text-muted-foreground">{b.body}</p>
              </section>
            </FadeUp>
          ))}
        </div>
      </div>
    </main>
  );
}
